import { API_URL as ENDPOINT } from "../config/env";

/** Lista las versiones del presupuesto de un proyecto, más nueva primero. */
export async function PresupuestoVersionesGet(proyectoId, token) {
  return fetch(`${ENDPOINT}PresupuestoVersionesGet/${proyectoId}`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "get",
    cache: "no-store",
  }).then((res) => res.json());
}

/** Crea una versión nueva como copia de la activa. */
export async function PresupuestoVersionCrear(data, token) {
  return fetch(`${ENDPOINT}PresupuestoVersionCrear`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

/** Marca una versión anterior como la activa. */
export async function PresupuestoVersionRestaurar(data, token) {
  return fetch(`${ENDPOINT}PresupuestoVersionRestaurar`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}
